import request from "superagent"
import { forEach } from "lodash/collection"
import State from "../stores/State"
import apiRequest from "../api"

export function saveArticle(data) {
  return new Promise(async (resolve, reject) => {
    data.type = "article"
    data.access_rights = "unmoderated"
    data.contributor_id = State.get("userId")
    data.contributor_name = State.get("usersName")

    try {
      const resource = await apiRequest("POST", "resources", data)

      const fileParams = {
        name: "article.json",
        mime_type: "application/json",
        type: data.type,
        contents: data.sections
      }

      const result = await apiRequest(
        "POST",
        `resources/${resource.id}/files`,
        fileParams
      )

      resolve(result)
    } catch (error) {
      reject(error)
    }
  })
}

export function saveImage(data, files) {
  return saveMedia(data, files)
}

export function saveMedia(data, files, onProgress, isEdit) {
  return new Promise(async (resolve, reject) => {
    const fields = {}
    const loggedIn = State.get("loggedIn")

    if (loggedIn) {
      forEach(data, (value, key) => {
        if (value !== null) {
          fields[key] = value
        }
      })

      fields.contributor_id = State.get("userId")
      fields.contributor_name = State.get("usersName")
      fields.access_rights = "unmoderated"

      if (!isEdit && (!files || (files && files.length == 0))) {
        reject(new Error("Files array is empty"))
        return
      }

      try {
        const resource = await apiRequest("POST", "resources", fields)

        if (!files || (files && files.length == 0)) {
          resolve(resource)
          return
        }

        let mimeType = files[0].type
        // hack around browser differences here ( chrome )
        const mimeTypesToReplace = ["audio/mp3", "audio/wav"]
        if (mimeTypesToReplace.indexOf(mimeType) !== -1) {
          mimeType = mimeType
            .replace("audio/mp3", "audio/mpeg")
            .replace("audio/wav", "audio/x-wav")
        }

        const fileParams = {
          name: files[0].name,
          mime_type: mimeType,
          type: data.type,
          size: files[0].size
        }

        const result = await apiRequest(
          "POST",
          `resources/${resource.id}/files`,
          fileParams
        )

        resolve(result)
      } catch (error) {
        let message = error && error.message

        try {
          message = error.json.messages.join(", ")
        } catch (_) {
          if (!message) {
            message = "Something went wrong"
          }
        }

        reject(new Error(message))
      }
    } else {
      reject(new Error("Not logged in"))
    }
  }).then(async res => {
    if (files.length > 0 && res.fields) {
      await s3Upload(res.url, files, res.fields, onProgress)

      return res
    }

    return res
  })
}

export function s3Upload(url, files, params, onProgress) {
  return new Promise(function(resolve, reject) {
    const req = request.post(url).set("Accept", "application/json")

    forEach(params, (value, key) => {
      if (value !== null) {
        req.field(key, value)
      }
    })

    //Set Files
    files.forEach(file => {
      req.attach("file", file)
    })

    if (onProgress) {
      req.on("progress", onProgress)
    }

    req.end((err, res) => {
      if (err) {
        reject(
          res && res.body && res.body.error ? new Error(res.body.error) : err
        )
      } else {
        if (!res.ok) {
          reject(new Error("Bad response"))
        } else {
          resolve(res)
        }
      }
    })
  })
}



// WEBPACK FOOTER //
// ./webapp/scripts/backend.js